export default {"src":"/_next/static/media/google.29739e57.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};